// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const ClaimRgaStatus = t.struct({
    color: t.String,
    status: t.String
}, {
    name: 'ClaimRgaStatus',
    strict: true
});

export const getDefaultState = () => new ClaimRgaStatus({
    color: '',
    status: ''
});

export default ClaimRgaStatus;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/claim-rga-status.js